import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/credit-utilization',
  component: () => import('../../routes/CreditUtilization.svelte'),
  card: {
    id: 'credit-utilization',
    title: 'Credit Utilization Calculator',
    description: 'Calculate your credit utilization ratio across multiple credit cards and see how it impacts your credit score.',
    icon: 'credit_score',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/credit-utilization',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Credit Utilization Calculator – Free Credit Score Health Tool',
    description: 'Free credit utilization calculator. Calculate your credit utilization ratio across all credit cards, see per-card breakdowns, and learn how to improve your credit score.',
  },
};

export default meta;